var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(`background-color: ${_vm.$vuetify.theme.dark ? '#1e1e1e' : '#F7F9FB'};`)},[_c('app-bar'),_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('ag-notify'),_c('update-me-container'),_c('switch-user-container'),_c('check-user-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }